export enum PomReportingStatus {
  Open = "Open",
  Reported = "Reported",
  Corrected = "Corrected",
}
